import { LoadableLazy } from '@confluence/loadable';

export { useConnectionsPanel } from '../src/ConnectionsPanel/useConnectionsPanel.ts';
export const EditorContextConnectionsPanel = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-appreferentiality" */ '../src/ConnectionsPanel/EditorContextConnectionsPanel.tsx'
			)
		).EditorContextConnectionsPanel,
});
